export const WYSIWYG_EDITOR_DEFAULT_MIN_HEIGHT = 200

export const WYSIWYG_EDITOR_DEFAULT_MAX_HEIGHT = 0

// below it the form scrolls instead of fixing the editor height
export const WYSIWYG_EDITOR_FULL_SCREEN_MIN_HEIGHT = 200

export const WYSIWYG_EDITOR_EVENT_BEFORE_SET_CONTENT = 'BeforeSetContent'

export const WYSIWYG_EDITOR_EVENT_GET_CONTENT = 'GetContent'

export const WYSIWYG_EDITOR_EVENT_EXEC_COMMAND = 'ExecCommand'

export const WYSIWYG_EDITOR_EVENT_PASTE_PRE_PROCESS = 'PastePreProcess'

export const WYSIWYG_EDITOR_EVENT_NEW_BLOCK = 'NewBlock'

export const WYSIWYG_EDITOR_EVENT_NODE_CHANGE = 'NodeChange'

export const WYSIWYG_EDITOR_EVENT_REMOVE = 'remove'

export const WYSIWYG_EDITOR_EVENT_RESIZE_CONTENT = 'ResizeContent'

export const WYSIWYG_EDITOR_EVENT_RESIZE_EDITOR = 'ResizeEditor'

export const WYSIWYG_EDITOR_EVENT_SELECTION_CHANGE = 'SelectionChange'

export const WYSIWYG_EDITOR_DEFAULT_CARET_SCROLL_MARGIN_BOTTOM = 0

export const WYSIWYG_EDITOR_SCROLLABLE_OVERFLOW_REGEXP = /(auto|scroll|overlay)/

export const WYSIWYG_EDITOR_OVERFLOW_HIDDEN = 'hidden'

export const WYSIWYG_EDITOR_POSITION_STICKY = 'sticky'

export const WYSIWYG_EDITOR_INSET_AUTO = 'auto'

export const WYSIWYG_EDITOR_CARET_HIT_TEST_INSET = 1

export const WYSIWYG_EDITOR_SKIN_LIGHT = 'oxide'

export const WYSIWYG_EDITOR_SKIN_DARK = 'oxide-dark'

export const WYSIWYG_EDITOR_CONTENT_STYLE_LIGHT = 'a { color: #0000EE; }'

export const WYSIWYG_EDITOR_CONTENT_STYLE_DARK = ':root { color-scheme: dark; }'
